import delay from './delay'

const DEFAULT_POLLING_INTERVAL_MS = 50

const waitFor = async (
  predicate: () => boolean,
  pollingIntervalMs = DEFAULT_POLLING_INTERVAL_MS
): Promise<void> => {
  while (!predicate()) {
    await delay(pollingIntervalMs)
  }
}

export default waitFor
